import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ICertificadoInfoDTO } from 'src/app/core/dto/certificado-info.dto';
import { ICertificadoTipoGeneracionDTO } from 'src/app/core/dto/certificado-tipo-generacion.dto';
import { IGrupoDTO } from 'src/app/core/dto/grupo.dto';
import { IMenuCertificacionesDTO } from 'src/app/core/dto/menu-certificaciones.dto';
import { CertificacionesService } from 'src/app/core/servicios/certificaciones.service';
import { CertificadoService } from 'src/app/core/servicios/certificado.service';
import { SeguridadService } from 'src/app/core/servicios/seguridad.service';
import { UtilidadService } from 'src/app/core/servicios/utilidad.service';
import { ModalCargandoComponent } from 'src/app/shared/componentes/modal-cargando/modal-cargando.component';
import { ModalConfirmacionComponent } from 'src/app/shared/componentes/modal-confirmacion/modal-confirmacion.component';
import { ModalErrorComponent } from 'src/app/shared/componentes/modal-error/modal-error.component';
import { ModalExitoComponent } from 'src/app/shared/componentes/modal-exito/modal-exito.component';

@Component({
  selector: 'app-menu-certificaciones',
  templateUrl: './menu-certificaciones.component.html',
  styleUrls: ['./menu-certificaciones.component.css']
})
export class MenuCertificacionesComponent implements OnInit {

  @ViewChild('popupVistaPrevia', { static: false }) popupVistaPrevia!: TemplateRef<any>;

  public titulo = 'Menú de certificados';
  public encabezados: string[] = ['Comprobante','Periodo','Fecha de pago','Valor','Tipo','Acción'];
  public certificaciones: IMenuCertificacionesDTO[] = [];
  public certificadoInfo!: ICertificadoInfoDTO;
  public perfil: IGrupoDTO | null = null;

  form: FormGroup;
  public selectCertificadoTipoGeneracion: FormControl;

  constructor(
    private fb: FormBuilder,
    private utilidadService: UtilidadService,
    private cerServie: CertificacionesService,
    private modalService: NgbModal,
    private certificadoCervice: CertificadoService,
    private seguridadService: SeguridadService
  ) { 
    this.form = this.fb.group({
      codigo: this.fb.control(''),
      identificacion: this.fb.control('')
    });

    this.selectCertificadoTipoGeneracion = this.fb.control('', Validators.compose([Validators.required]));
  }

  ngOnInit(): void {
    this.getMenuCertificacionesPorUsuario();
    this.getPerfilSesion();
  }

  private getPerfilSesion():void{
    this.seguridadService.getPerfilEnSesion().subscribe(
      (res) => {
        //console.log(res);
        this.perfil = res;
      },
      (err) =>{
        //console.error(err);
      }
    );
  }

  // Fetchs

  getMenuCertificacionesPorUsuario():void{

    this.modalService.open(ModalCargandoComponent, { animation: true, backdrop: 'static', keyboard: false });

    this.cerServie.getMenuCertificacionesPorUsuario().subscribe(
      (res) =>{
        this.modalService.dismissAll();
        this.certificaciones = res;
      },
      (err)=>{
        //console.error(err);
        this.modalService.dismissAll();
        const refError = this.modalService.open(ModalErrorComponent, { animation: true, backdrop: 'static', keyboard: false });
        refError.componentInstance.mensaje = 'Ha ocurrido un error al obtener las certificaciones del usuario';
      }
    );
  }


  onClickGenerarFichaAcademicaGraduado(certificado: any): void {
    const refConfirmacion = this.modalService.open(ModalConfirmacionComponent, { animation: true, backdrop: 'static', keyboard: false });
    refConfirmacion.componentInstance.mensaje = '¿Desea generar la ficha académica?';
    refConfirmacion.result.then((res: boolean) => {
      if (res) {
        //console.log(res);
        this.generarFichaAcademicaGraduado(certificado);
      }
    }
    )
}

private generarFichaAcademicaGraduado(certificado: any): void {

  this.modalService.open(ModalCargandoComponent, { animation: true, backdrop: 'static', keyboard: false });

  this.cerServie.generarFichaAcademicaGraduado(certificado.liq_codigo.toString()).subscribe(
    (res) => {
      //console.log(res);
      //console.info(res);
      this.modalService.dismissAll();
      this.getMenuCertificacionesPorUsuario();
      const refExito = this.modalService.open(ModalExitoComponent, { animation: true, backdrop: 'static', keyboard: false });
      refExito.componentInstance.mensaje = 'Se ha generado la ficha académica exitosamente';

      this.utilidadService.descargarArchivo(res.body, 'blob', 'ficha_academica_' + certificado.liq_codigo.toString(), '.pdf');

    }, (err) => {
      //console.error(err)
      this.modalService.dismissAll();

      this.utilidadService.fromBlobToHttpErrorResponse(err.error, (res: any) => {

        const errorResponse = JSON.parse(res);

        const error:HttpErrorResponse = new HttpErrorResponse({
          error: errorResponse,
          headers: errorResponse.headers,
          status: errorResponse.status,
          statusText: errorResponse.statusText,
          url: errorResponse.url
      })

        const refError = this.modalService.open(ModalErrorComponent, { animation: true, backdrop: 'static', keyboard: false });
        refError.componentInstance.titulo = 'Aclaración';
        refError.componentInstance.icono = 'bi bi-exclamation-octagon icono-confirmacion';
        refError.componentInstance.mensaje = this.utilidadService.procesarError(error);
      });


    }
  );
}
getTipoGeneracion(): AbstractControl | null {
  return this.selectCertificadoTipoGeneracion;
}
}
